var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Flex } from '@chakra-ui/react';
import React from 'react';
import { FormProvider, } from 'react-hook-form';
var Form = function (_a) {
    var children = _a.children, onSubmit = _a.onSubmit, _b = _a.childrenContainerProps, childrenContainerProps = _b === void 0 ? {} : _b, formId = _a.formId, methods = _a.methods;
    var handleSubmit = methods.handleSubmit;
    return (React.createElement(FormProvider, __assign({}, methods),
        React.createElement(Flex, __assign({ as: 'form', flexDir: 'column', id: formId, noValidate: true, onSubmit: handleSubmit(onSubmit) }, childrenContainerProps), children)));
};
export default Form;
//# sourceMappingURL=Form.js.map